import type { TQuoteMarkersPosition } from "@atoms/QuoteMarkers/types";

export const quotesPosition: TQuoteMarkersPosition[] = ["left", "right"];
